import { render, staticRenderFns } from "./InviteColleagueCard.vue?vue&type=template&id=2a893028&scoped=true"
import script from "./InviteColleagueCard.vue?vue&type=script&lang=js"
export * from "./InviteColleagueCard.vue?vue&type=script&lang=js"
import style0 from "./InviteColleagueCard.vue?vue&type=style&index=0&id=2a893028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a893028",
  null
  
)

export default component.exports